// 配置全局访问接口地址
// let commonUrl = 'https://testyinji.gaoshan.co'
// let queryUrl = 'https://testquery.gaoshan.co'
// let checkUrl = 'https://testcheck.gaoshan.co'
let commonUrl = 'https://www.yinji.pro'
let queryUrl = 'https://www.yinji.pro/query/#/'
let checkUrl = 'https://www.yinji.pro/check/#/'
let baseUrl = {
  commonUrl,
  queryUrl,
  checkUrl
}
export default baseUrl
